module.exports = "https://static.wmbcdn.com/uniweb/images/d1e4dbd4bfe159a4ce02408c75a0bcc0.svg";